export enum ComponentType {
  Step = 'Step',
  FieldHidden = 'FieldHidden',
  FieldText = 'FieldText',
  FieldTextarea = 'FieldTextarea',
  FieldSelect = 'FieldSelect',
  FieldRadio = 'FieldRadio',
  FieldCheckbox = 'FieldCheckbox',
}
